module.exports = __webpack_public_path__ + "static/media/banner-one.9e6b0ca5.png";